import { render, staticRenderFns } from "./AppChart.vue?vue&type=template&id=22fc12f1"
import script from "./AppChart.vue?vue&type=script&lang=js"
export * from "./AppChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports